var exports = {
  "r": "propertiesListContainer__hOApqh",
};

module.exports = exports;
